<template>
   <div class='Pausados'>
        <div v-if="loading">
            <div class="d-flex justify-content-center mt-5">
                <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        </div>
        <div v-else>
            <div v-if="projectos == null">
                <div class="row pt-3">
                    <div class="col">
                        <div class="card">
                            <p class="text-center pt-2">Sin Proyectos</p>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <!-- Tabla -->
                <table class="table">
                <thead>
                    <tr>
                        <th scope="col" style="width: 20%">Nombre Proyecto</th>
                        <th scope="col" >Adjudicado a:</th>
                        <th scope="col">Pais</th>
                        <th scope="col">Fecha Adjudicado </th>
                        <th scope="col">Fecha Inicio</th>
                        <th scope="col">Fecha Entrega</th>
                        <th scope="col">Notas</th>
                        <th scope="col">Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="f in projectos" :key="f.id">
                        <td>
                            <router-link :to="{ name: 'DetalleProyecto', params: { idEmpresa: f.id_proyecto}}"> 
                                {{f.titulo_proyecto}} 
                                <span v-if="f.asignadaA != 0">
                                    <small class="text-success">(Adjudicado)</small>
                                </span>
                            </router-link>
                        </td>
                        <!--Adjudicado a -->
                        <td>
                            <div class="row">
                                <div class="col-3">
                                    <img :src="getUrl(f.avatar)" class="img">
                                </div>
                                <div class="col-9">
                                    <router-link :to="{ name: 'calificacion', params: {id: f.id_user}}">
                                        @{{f.usuario}}
                                    </router-link>
                                    <star-rating :increment="0.1" :rating="makeNumber(f.estrellas)" :star-size="20" :show-rating="false" :read-only="true"/>
                                </div>
                            </div>
                        </td>
                        <td>
                            <img :src="getBandera(f.pais_region)" class="bandera">
                        </td>
                        <td>{{fechaFormat(f.fecha_adj)}}</td>
                        <td>{{fechaFormat(f.fecha_inicio)}}</td>
                        <td>{{fechaFormat(f.fecha_cierre)}}</td>
                        <td>
                            {{f.razonPausado}}
                        </td>
                        <td>
                            <button class="btn btn-sm btn-success" @click="quitarPausa(f)"> 
                                <font-icon icon="play"/>
                            </button>
                            <button class="btn orange btn-sm" @click="regChat(f.id_user,f.id_proyecto)">
                                <font-icon icon="comments"/>
                            </button>
                        </td>
                    </tr>
                </tbody>
                </table>
            </div>
        </div>
   </div>
</template>


<script>
import { mapState } from 'vuex'
import { globalFunctions } from '@/hooks/globalFunctions'
import StarRating from 'vue-star-rating'

export default {
name: 'Pausados',
components:{ StarRating },
mixins: [ globalFunctions ],
data () {
    return {
        projectos: [],
        loading: true,
    }
},
methods: {
    getData(){
        let data = {
            id: localStorage.userID,
            prop: 6,
            flag: 0
        };
    
        this.axios.post(this.url + 'getProyectos.php',data).then((responce) =>{
            this.projectos = responce.data;
            this.loading = false;
        });
    },

    regChat(consultor, proyecto){
        let data = {
            flag: 0,
            idProyecto: proyecto,
            idEmpresa: localStorage.userID,
            idConsultor: consultor
        }

        this.axios.post(this.url + 'altaChat.php', data).then((responce) =>{
            if(responce.data == 200){
                this.$router.push('/Blog?tabla=' + consultor + '&tabla2=' + proyecto);
            }
        })
    },

    quitarPausa(f){
        
        if(f.quienPauso == 0){
            alert("Proyecto pausado, para reanudar su ejecución contactar con el consultor.");
            return;
        }

        let data = {
            flag:6,
            num: 4, //status
            id: f.id_proyecto,
            razon: ''
        };
        
        this.axios.post(this.url + 'postProyectos.php', data).then((responce) =>{
            if(responce.data == 200){
                this.msjOk("Proyecto Reanudado");
                this.getData();
                this.$emit("update");
            }
        });
    },
},
computed:{
    ...mapState(['url'])
},
mounted(){
    this.getData();
}
}
</script>


<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/Proyectos/components/Empresa/Pausados.vue